module.exports = __webpack_public_path__ + "static/media/car-1-woodridge.15fdde0f.png";